import { ResourceOptions } from 'react-admin';
import { FaCoins } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.perpsV1Symbols;
export const icon = FaCoins;
export const options: ResourceOptions = {
  label: 'resource.perpsV1Symbols',
};
